(function(){
    'use strict';

    angular
    .module('app')
    .controller('DefaultController', DefaultController)
 
    DefaultController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function DefaultController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.hide_filter = false;
        vm.hide_view = false;


        vm.update = function(){

        	var j = JSON.parse($('#fieldconfig-value').val());

			/*var j = {
				"references":{
					"busqueda":vm.busqueda,
                    "field":vm.field,
					"modificable":vm.modificable
				}
			};*/
			j.references["hide_filter"] = vm.hide_filter;
			j.references["hide_view"] = vm.hide_view;
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }

        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		if(typeof vm.json.references.hide_filter!='undefined'){
                    vm.hide_filter = vm.json.references.hide_filter;
                }
                if(typeof vm.json.references.hide_view!='undefined'){
                    vm.hide_view = vm.json.references.hide_view;
                }
                
        	}
        	vm.update();
        }
    } 

})();